import React, { Component } from 'react';
import { connect } from 'react-redux';

import styles from './styles';

const {
    ModalContent,
    ModalTitle,
    ModalText,
    ModalTextContainer,
    Modal,
    ModalPhone,
    ModalSmallText,
    ModalName,
} = styles;

export class ModalInvalidStatusLink extends Component {
    componentDidMount() {
        document.querySelector('body').classList.add('overflow');
    }

    componentWillUnmount() {
        document.querySelector('body').classList.remove('overflow');
    }

    render() {
        const {
            status: {
                data: {
                    order: {
                        firstName,
                        lastName,
                    } = {},
                },
                isLoaded,
            },
            paymentTimeIsOver,
        } = this.props;

        return isLoaded && paymentTimeIsOver ? (
            <Modal>
                <ModalContent>
                    <ModalTitle>Проверка статуса платежа</ModalTitle>
                    <ModalTextContainer>
                        <ModalName>{firstName} {lastName},</ModalName>
                        <ModalText>
                            срок действия ссылки истек.
                            Для уточнения статуса платежа
                            обратитесь, пожалуйста, в
                            Службу клиентской поддержки
                            АО «Тойота Банк».
                        </ModalText>
                        <ModalPhone>8 (800) 350-38-83</ModalPhone>
                        <ModalSmallText>Круглосуточно, без выходных</ModalSmallText>
                    </ModalTextContainer>
                </ModalContent>
            </Modal>
        ) : null;
    }
}

export default connect(
    state => ({
        status: state.brand.status,
    }),
    null,
)(ModalInvalidStatusLink);
